export enum ValueType {
  Text = "Text",
  Number = "Number",
  List = "List",
  Entity = "Entity",
  Boolean = "Boolean",
  Money = "Money",
  Percentage = "Percentage",
}

export enum Relationship {
  OneToOne = "<~>",
  OneToMany = "<~",
  ManyToOne = "~>",
  ManyToMany = "~",
}

export enum ModelLogLevel {
  Off = "off",
  Error = "error",
  Warn = "warn",
  Info = "info",
  Debug = "debug",
  Trace = "trace",
}
